// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_info:not(li) > p:first-of-type {
  margin-bottom: 40px;
}

ion-content {
  padding: 10px 10px 0;
  --padding-end: 20px;
  --padding-top: 30px;
  --padding-bottom: 20px;
  --padding-start: 10px;
}

.acordion-wrapper {
  justify-content: center;
  align-items: center;
}

ion-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);
}
ion-footer .link {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  border-right-width: 2px;
  border-right-style: solid;
  border-image: linear-gradient(180deg, rgb(255, 255, 255) 20%, rgb(82, 19, 64) 20%, rgb(82, 19, 64) 85%, rgb(255, 255, 255) 85%);
  border-image-slice: 1;
  color: #521340;
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 121.4%; /* 19.424px */
  letter-spacing: 0.32px;
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
  text-transform: capitalize;
}
ion-footer .link:last-child {
  border-right: none;
}

strong {
  font-family: AppFontBlack, san-serif !important;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.14px;
}

table {
  width: 100%;
  border: 1px solid var(--ion-color-primary);
  margin-top: 10px;
}
table td {
  padding: 15px;
}
table p {
  font-family: AppFont600, san-serif;
  color: var(--ion-color-primary);
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.14px;
}

.nested-list,
.nested-list > li > ul {
  list-style-type: none;
}

.nested-list > li {
  counter-increment: list;
  font-family: AppFontBlack, san-serif !important;
  font-size: 18px !important;
  line-height: 16px !important;
  letter-spacing: 0.14px;
  color: var(--ion-color-primary);
  margin-top: 15px;
}

.nested-list > li > ul > li span {
  font-family: AppFont600, san-serif;
  color: var(--ion-color-primary);
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.14px;
}

p {
  font-family: AppFont600, san-serif;
  color: var(--ion-color-primary);
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.14px;
}

.nested-list > li:before {
  content: counter(list) ". ";
}

.nested-list > li > ul > li {
  counter-increment: sublist;
  display: flex;
  margin-top: 15px;
}

.nested-list > li > ul > li:before {
  content: counter(list) "." counter(sublist) ". ";
  margin-right: 10px;
}

.nested-list > li > ul {
  padding-left: 0;
}

.empty::before {
  display: none;
}

.first_ul {
  padding-left: 0;
  margin-bottom: 30px;
}

.main_title {
  font-family: AppFontBlack, san-serif !important;
  font-size: 18px !important;
  line-height: 23px !important;
  letter-spacing: 0.14px;
  color: var(--ion-color-primary);
}

.dash-list > span {
  padding-left: 20px;
}

.padding-block {
  margin: 20px 0px 20px 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tos/tos.page.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;AACD;;AAEA;EACC,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;AACD;;AAEA;EAEC,uBAAA;EACA,mBAAA;AAAD;;AAIA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gDAAA;AADD;AAEC;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,+HAAA;EAOA,qBAAA;EAEA,cAAA;EAEA,wBAAA;EACA,eAAA;EACA,mBAAA,EAAA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,0BAAA;AARF;AAUE;EACC,kBAAA;AARH;;AAaA;EACC,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAVD;;AAqBA;EACC,WAAA;EACA,0CAAA;EACA,gBAAA;AAlBD;AAmBC;EACC,aAAA;AAjBF;AAqBC;EACC,kCAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAnBF;;AAuBA;;EAEC,qBAAA;AApBD;;AAuBA;EACC,uBAAA;EACA,+CAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,+BAAA;EACA,gBAAA;AApBD;;AAuBC;EACC,kCAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AApBF;;AAuBA;EACC,kCAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AApBD;;AAsBA;EACC,2BAAA;AAnBD;;AAsBA;EACC,0BAAA;EACA,aAAA;EACA,gBAAA;AAnBD;;AAsBA;EACC,gDAAA;EACA,kBAAA;AAnBD;;AAsBA;EACC,eAAA;AAnBD;;AAsBA;EACC,aAAA;AAnBD;;AAsBA;EACC,eAAA;EACA,mBAAA;AAnBD;;AAsBA;EACC,+CAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,+BAAA;AAnBD;;AAsBA;EACC,kBAAA;AAnBD;;AAqBA;EACC,0BAAA;AAlBD","sourcesContent":[".dialog_info:not(li) > p:first-of-type {\n\tmargin-bottom: 40px;\n}\n\nion-content {\n\tpadding: 10px 10px 0;\n\t--padding-end: 20px;\n\t--padding-top: 30px;\n\t--padding-bottom: 20px;\n\t--padding-start: 10px;\n}\n\n.acordion-wrapper {\n\t// display: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n}\n\nion-footer {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 64px;\n\tbox-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.05);\n\t.link {\n\t\tflex-grow: 1;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tpadding: 8px;\n\t\tmargin: 0;\n\t\tborder-right-width: 2px;\n\t\tborder-right-style: solid;\n\t\tborder-image: linear-gradient(\n\t\t\t180deg,\n\t\t\trgba(255, 255, 255, 1) 20%,\n\t\t\trgba(82, 19, 64, 1) 20%,\n\t\t\trgba(82, 19, 64, 1) 85%,\n\t\t\trgba(255, 255, 255, 1) 85%\n\t\t);\n\t\tborder-image-slice: 1;\n\n\t\tcolor: #521340;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 121.4%; /* 19.424px */\n\t\tletter-spacing: 0.32px;\n\t\ttext-decoration-line: underline;\n\t\ttext-underline-offset: 0.2em;\n\t\ttext-transform: capitalize;\n\n\t\t&:last-child {\n\t\t\tborder-right: none;\n\t\t}\n\t}\n}\n\nstrong {\n\tfont-family: AppFontBlack, san-serif !important;\n\tfont-size: 14px;\n\tline-height: 23px;\n\tletter-spacing: 0.14px;\n}\n// .title {\n// \tfont-family: var(--font-tusker), sans-serif !important;\n// \tcolor: var(--ion-color-primary) !important;\n// \tfont-size: 26px;\n// \tline-height: 30px;\n// \t&:first-child {\n// \t\tpadding: 0 30px 10px 0;\n// \t}\n// }\ntable {\n\twidth: 100%;\n\tborder: 1px solid var(--ion-color-primary);\n\tmargin-top: 10px;\n\ttd {\n\t\tpadding: 15px;\n\t}\n\tstrong {\n\t}\n\tp {\n\t\tfont-family: AppFont600, san-serif;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-size: 14px;\n\t\tline-height: 23px;\n\t\tletter-spacing: 0.14px;\n\t}\n}\n\n.nested-list,\n.nested-list > li > ul {\n\tlist-style-type: none;\n}\n\n.nested-list > li {\n\tcounter-increment: list;\n\tfont-family: AppFontBlack, san-serif !important;\n\tfont-size: 18px !important;\n\tline-height: 16px !important;\n\tletter-spacing: 0.14px;\n\tcolor: var(--ion-color-primary);\n\tmargin-top: 15px;\n}\n.nested-list > li > ul > li {\n\tspan {\n\t\tfont-family: AppFont600, san-serif;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-size: 14px;\n\t\tline-height: 23px;\n\t\tletter-spacing: 0.14px;\n\t}\n}\np {\n\tfont-family: AppFont600, san-serif;\n\tcolor: var(--ion-color-primary);\n\tfont-size: 14px;\n\tline-height: 23px;\n\tletter-spacing: 0.14px;\n}\n.nested-list > li:before {\n\tcontent: counter(list) '. ';\n}\n\n.nested-list > li > ul > li {\n\tcounter-increment: sublist;\n\tdisplay: flex;\n\tmargin-top: 15px;\n}\n\n.nested-list > li > ul > li:before {\n\tcontent: counter(list) '.' counter(sublist) '. ';\n\tmargin-right: 10px;\n}\n\n.nested-list > li > ul {\n\tpadding-left: 0;\n}\n\n.empty::before {\n\tdisplay: none;\n}\n\n.first_ul {\n\tpadding-left: 0;\n\tmargin-bottom: 30px;\n}\n\n.main_title {\n\tfont-family: AppFontBlack, san-serif !important;\n\tfont-size: 18px !important;\n\tline-height: 23px !important;\n\tletter-spacing: 0.14px;\n\tcolor: var(--ion-color-primary);\n}\n\n.dash-list > span {\n\tpadding-left: 20px;\n}\n.padding-block {\n\tmargin: 20px 0px 20px 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
